import { render } from "./CheckmarkIcon.vue?vue&type=template&id=1bd4da0a"
import script from "./CheckmarkIcon.vue?vue&type=script&lang=ts"
export * from "./CheckmarkIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script